import type { SourceResource } from "@prequel/import-react";
import { type ListSourcesOptions, useListSources } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import VendorLogo from "@/components/VendorLogo";
import { useRequiredParam } from "@/layouts/Navigation/useRequiredParam";
import { getVendorLabel, getVendorLogoUrl } from "@/pages/import/vendors";

const COLUMNS = ["Name", "Vendor", "Created"];

const mapSourceToRow = (source: SourceResource): TableRow => ({
  id: source.id,
  to: `/import/sources/${source.id}`,
  cells: [
    { value: source.name },
    {
      value: (
        <div className="flex items-center">
          <VendorLogo logo_url={getVendorLogoUrl(source.vendor)} />
          {getVendorLabel(source.vendor)}
        </div>
      ),
    },
    { value: <Timestamp timestamp={source.created_at} /> },
  ],
});

// Reads the provider from the route rather than a prop so it satisfies ResourceTable's
// useQuery contract, which only forwards pagination params.
const useProviderSources = (options?: ListSourcesOptions) => {
  const providerID = useRequiredParam("providerID");

  return useListSources({ ...options, providerId: providerID });
};

const ProviderSources = () => {
  return (
    <ResourceTable<SourceResource>
      columns={COLUMNS}
      useQuery={useProviderSources}
      rowMapper={mapSourceToRow}
      emptyMessage="No sources configured for this provider."
    />
  );
};

export default ProviderSources;
